export const cancelCodeOptions = [
  {
    value: "116",
    label: "จดหมายส่งผู้ค้ำ (116)",
    children: [
      { value: "P21", label: "P21" },
      { value: "P22", label: "P22" },
      { value: "P23", label: "P23" },
      { value: "P31", label: "P31" },
      { value: "P32", label: "P32" },
      { value: "P33", label: "P33" },
      { value: "P41", label: "P41" },
    ],
  },
  {
    value: "119",
    label: "บอกเลิกสัญญาผู้เช่าซื้อ (119)",
    children: [
      { value: "P11", label: "P11" },
      { value: "P12", label: "P12" },
      { value: "P13", label: "P13" },
    ],
  },
  {
    value: "129",
    label: "ค่าบอกเลิกสัญญา (EMS) (129)",
    children: [
      { value: "411", label: "411" },
      { value: "412", label: "412" },
      { value: "413", label: "413" },
      { value: "421", label: "421" },
      { value: "422", label: "422" },
      { value: "423", label: "423" },
      { value: "431", label: "431" },
      { value: "432", label: "432" },
      { value: "433", label: "433" },
      { value: "441", label: "441" },
      { value: "442", label: "442" },
      { value: "443", label: "443" },
      { value: "451", label: "451" },
      { value: "452", label: "452" },
      { value: "453", label: "453" },
      { value: "461", label: "461" },
      { value: "462", label: "462" },
      { value: "463", label: "463" },
    ],
  },
];
